import './style.scss'; 
 
import React, { FC } from 'react';

type BorderAnimateProps = {
    children: React.ReactNode;
};
const BorderAnimate: FC<BorderAnimateProps> = ({
   children
}) => {
  return (
      <div className="BorderAnimate">
          <svg height="100%" width="100%" xmlns="http://www.w3.org/2000/svg">
              <rect
                  rx="8"
                  ry="8"
                  className="line"
                  height="100%"
                  width="100%"
                  strokeLinejoin="round"
              />
          </svg>
          <div className="inner p-1">
              {children}
          </div>
      </div>
  );
}

export default BorderAnimate; 
